export const getKeyData = (state, { key, initialState } = {}) => {
  if (!key) {
    throw new Error('key is required');
  }

  const keyData = state && state[key];

  if (keyData && keyData.initialized) {
    return keyData;
  }

  return {
    failed: false,
    loading: false,
    data: initialState,
  };
};
